import { useMutation } from "@tanstack/react-query";
import { useDispatch } from "react-redux";

import { showSuccessToast } from "app/actions/toast_actions";
import { getToastItemComponent } from "app/components/React/Toast/ToastItem";
import { translate } from "app/filters/i18nFilter";
import type { IWebhookSubscriptionBaseModel } from "app/pages/sales-intelligence/modules/signals-api-webhook/types/row-data";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import { webhookSubscriptionsQueryKeys } from "../key-factory/factory";

export const useTestWebhookSubscriptionMutation = () => {
    const dispatch = useDispatch();

    return useMutation({
        mutationKey: webhookSubscriptionsQueryKeys.test(),
        retry: 2,
        retryDelay: 200,
        mutationFn(subscription: IWebhookSubscriptionBaseModel) {
            return salesApiService.management.testWebhookSubscription(subscription);
        },
        onSuccess() {
            dispatch(
                showSuccessToast(
                    getToastItemComponent({
                        text: translate("si.management.integration.signals-api.section.webhook.test-completed"),
                    }),
                ),
            );
        },
    });
};
